<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
  <p *ngIf="data.error" class="mt-4">
    <span class="italic text-sm">Error: {{ data.error.message }}</span>
  </p>
  <p *ngIf="data.eventId" class="mt-4">
    <span class="italic text-sm">Event Id: {{ data.eventId }}</span>
  </p>
</div>
<div mat-dialog-actions>
  <button class="w-40" mat-flat-button [color]="'primary'" (click)="onOk()" cdkFocusInitial>Ok</button>

  <button *ngIf="data.eventId" class="w-40" mat-flat-button [color]="'primary'" (click)="onSendErrorReport()">
    Send Error Report
  </button>
</div>
